import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import CostViewModel from '@app/models-internal/cost-view-model';
import PermitInstance from '@app/models/permit-instance';
import PermitInstancePurchaseModel from '@app/models/permit-instance-purchase-model';
import { StripeSource } from '@oa/shared-core';

import { ListingPermitViewModel, PermitCountViewModel } from '../models';
import { DateService } from '@oa/shared-core';
import { FileDownloadService } from '@oa/shared-core';
import { PaymentService } from './payment.service';
import PermitInstanceGridRowViewModel from '@app/models/permit-instance-grid-row-view-model';

@Injectable()
export class PermitInstanceService {

  private readonly _serviceName = 'PermitInstanceService';
  constructor(private http: HttpClient, private fileDownloadService: FileDownloadService, private paymentService: PaymentService
    ,private dateHelper:DateService) {}



    /**
     * Purchases a new permit 
     * @param permitId 
     * @param stripeSource 
     * @param startDateISOString 
     */
  public purchase(permitId: number, paymentIntentId: string | null, startDateISOString:string) {
    console.log(`${this._serviceName}.purchase() permitId=${permitId}, paymentIntentId=`,paymentIntentId);
    // paymentIntentId is null when credits cover the full order total - the API only
    // requires one when there is an amount left to charge.

    let startDate:Date = null;

    if (startDateISOString){
      startDate = this.dateHelper.parseDate(startDateISOString);
    }

    let model = {permitId : permitId, paymentIntentId:paymentIntentId, startDate: startDate } as PermitInstancePurchaseModel;

    return this.http.post<PermitInstancePurchaseModel>('PermitInstance', model );
  }

  getUserPermits(userId: number) {
    if (Number.isNaN(userId)) {
      let msg = `Invalid User ID value:  ${userId}`;
      console.error(msg);
      throw new Error(msg);
    }

    if (userId == 0) {
      let msg = `Invalid User ID value:  ${userId}`;
      console.error(msg);
      throw new Error(msg);
    }

    // 
    return this.http.get<ListingPermitViewModel[]>(`PermitInstance/user/${userId}`);
  }

  //getPermitInstance(bookingId: string) {
  //  return this.http.get<PermitInstance[]>(`PermitInstance/${bookingId}`);
  //}

  getListingPermits(listingId: number) {
    return this.http.get<ListingPermitViewModel[]>(`PermitInstance/listing/${listingId}`);
  }


  public getAllPermitInstances() {
    return this.http.get<PermitInstanceGridRowViewModel[]>('PermitInstance');
  }

  /**
   * Gets a permit count for permit types on a listing
   * @param listingId
   */
  getPermitCount(listingId: number) {
    return this.http.get<PermitCountViewModel[]>(`PermitInstance/listing/${listingId}/count`);
  }

  /**
   * Downloads the export file (Excel spreadsheet)
   * @param exportFile
   */
  downloadListingPermitData(listingId: number) {
    if (listingId == 0) {
      let msg = `Invalid Listing ID value:  ${listingId}`;
      console.error(msg);
      throw new Error(msg);
    }

    return this.fileDownloadService.downloadFile(`permitinstance/listing/${listingId}/data`);
  }


  /**
   * Get the cost of a permit
   */
  public getCost(permitId:number) {
    return this.http.get<CostViewModel>(`PermitInstance/${permitId}/cost`);
  }

  /**
   * Toggles auto-renew on or off for a permit instance.
   * @param permitInstanceId
   * @param autoRenew
   */
  public toggleAutoRenew(permitInstanceId: number, autoRenew: boolean) {
    return this.http.post('PermitInstance/autorenew', { permitInstanceId, autoRenew });
  }
}
